import React from 'react';
import PropTypes from 'prop-types';
import { Alert} from 'antd';


function ApiArticulos(props) {
    
    const dataArticulos = props.dataArticulos?props.dataArticulos:null

    const Articulos =
        ( dataArticulos.Status == 1 ? <div style={{textAlign:"left"}}> 
            <h4> Detalle Articulos Intelisis: </h4>
            <table className="table table-bordered"><thead><tr><th>Articulo</th><th>Descripcion</th></tr></thead><tbody>
            { dataArticulos.Servicios.map( (item, id)  => {
                 return (  <tr key={id} >
                                <td width="4%"  >{item.Articulo}</td>
                                <td width="10%" >{item.DescripcionExtra}</td>
                            </tr>
                        ) 
                }) 
                
            }</tbody></table> 
        </div>:  <div><Alert message="sin Informacion en Api ... !" type="warning" /></div>  )

    return (
        <div>
        {Articulos}
        </div>
        
    );
}

export default ApiArticulos;
